import { SHOW_MOBILE_NAVIGATION } from './actionTypes';

const mobileNavigation = isOpen => ({ type: SHOW_MOBILE_NAVIGATION, isOpen });

export default mobileNavigation;
